"use client";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from "react";

/**
 * A custom hook that executes a callback only once during component's lifecycle
 * @param callback Function to be executed once
 * @param dependencies Optional dependency array for the effect
 */
export const useOnce = (
  callback: () => void | undefined | (() => void),
  dependencies: any[] = [],
) => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      return callback();
    }
  }, dependencies);
};
